import { USER_ROLES } from 'constants/constants';

/**
 * Checks if the user has write access based on their roles for a project.
 * Users with Admin, Engineer, or Editor roles (level >= 300) have write access.
 *
 * @param {Array} userActiveRoles - Array of user role objects for the current project
 * @returns {boolean} - True if the user has write access, false otherwise
 */
export function hasWriteAccess(userActiveRoles) {
  const WRITE_ACCESS_MIN_LEVEL = USER_ROLES.EDITOR.level;
  return userActiveRoles.some(role => role.level >= WRITE_ACCESS_MIN_LEVEL);
}

/**
 * Returns the user's highest role in a project.
 *
 * @param {Object} projectRoles
 * @returns {Object|undefined} - The highest role object from USER_ROLES, or undefined if no roles
 */
export function getHighestRole(projectRoles) {
  if (!projectRoles) return undefined;

  return Object.values(USER_ROLES)
    .sort((a, b) => b.level - a.level)
    .find((role) => projectRoles[role.name]);
}
